<template>
	<div class="mhomeCntainer">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<!-- <img class="lansuImg" src="../../assets/mImg/mNewLanshuLogo.png" alt=""> -->
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<img class="mhomeFirst"
				src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_10-42-52_28835.png">
			<!-- <div class="mFirstBox">
				<div class="mFirstBoxImgBox" @click="open">
					<img class="mFirstBoxImg" src="../../assets/mImg/whiteMenu.png" alt="">
				</div>
			</div> -->
		</div>
		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- 	<el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>
		</el-drawer>

		<div class="mhomeSecondBox">
			<!-- <div class="aboutLanSuImgBox">
				<img class="aboutLanSuImg"
					src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-51-04_91155.jpeg"
					alt="">
			</div> -->
			<div class="titleContentBox">
				<div class="homeLine"></div>
				<div class="titleIntro">走进兰树</div>
				<div class="titleAbout">LASUR INTRODUCTION</div>
				<div class="mhomeSecondMainText1">
					兰树化妆品股份有限公司（以下简称公司或兰树）是一家集研发、生产、销售、服务为一体的化妆品公司，旗下拥有“淮树”、“一清堂”、“心清堂”和“水姻缘”四大品牌（以下合称“兰树品牌”）。“兰树品牌”创立至今，一直秉持“取自然之本，集万物精粹”的养肤理念，传承东方养肤智慧，融合现代尖端科学技术，致力于打造更适合东方肌肤的化妆品。
				</div>
				<!-- <div class="mhomeSecondMainText2">
					兰，纳百川，最丰沛的健康美丽能量，源自生生不息的自然世界；树，以植物为灵魂，凝古方智慧和现代科技的力量，兰树，给予最完美的身心灵健康答案。兰馨启德，玉树常青 ----兰树，应运而生。
				</div> -->
				<div class="learnMore" @click="enterAboutUs()">了解更多兰树信息</div>
			</div>
		</div>

		<div class="mhomeThirdBox">
			<wc-swiper class="swiperItemBox">
				<wc-slide v-for="(item,index) in swiperData" :key="index" :class="styleData[index]">
					<div class="swiperBoxMain">
						<div class="swiperImgBox">
							<img class="swiperImg" :src="item.titleImg" alt="">
						</div>
						<div class="swiperTitleBox">
							<div class="swiperTitle">{{item.title1}}</div>
							<div class="swiperContent">{{item.introduce}}</div>
							<div class="learnMore" @click="enterBrand(item.id)">查看更多内容</div>
						</div>
					</div>
				</wc-slide>
			</wc-swiper>
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

export default {
	data() {
		return {
			drawer: false,
			direction: 'ltr',
			swiperData: [
				{
					id: 1,
					introduce: '秉承“天然、安全、有效”的护肤理念，以先进技术凝萃,提取植物中蕴含的高活性精华，探索草本护肤能量，以新鲜植萃唤醒肌肤活力，为广大爱美人士提供天然亲肤的纯净美肌方案，尽享植萃呵护。',
					title1: '皮肤美丽顾问',
					titleImg: 'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_10-41-11_6622.png'
				},
				{
					id: 2,
					introduce: '秉持“中学为体、西学为用”的品牌发展理念，将西方科技融入东方智慧，以植物生命能量修护肌肤功能，用生物科技修护肌肤结构，用科技引领护肤新体验。',
					title1: '科技护肤引领者',
					titleImg: require('../../assets/mImg/xinSwiperNew.jpg')
				},
				{
					id: 3,
					introduce: '追求肌肤的“自然美、平衡美、活力美”，遵循"炮制虽繁必不敢省人工，品味虽贵必不敢减物力"的中药行原则，严苛选料、精研品质，专注问题性肌肤，从身、心、灵多方位修护肌肤。',
					title1: '专注问题性肌肤修护',
					titleImg: require('../../assets/mImg/yiSwiper.jpg')
				},
				{
					id: 4,
					introduce: '因循东方美学的协调法则，“以水养肤，姻水结缘”，溯源水的至纯之美，以水能量沁润美肌，令肌肤回归至净本源，展现典雅的东方底蕴。',
					title1: '皮肤管理顾问',
					titleImg: require('../../assets/mImg/shuiSwiper.jpg')
				},
				// {
				// 	id: 5,
				// 	introduce: '以蕴郁生机、自然草本、科学养肌为指导理念，将产品的安全性、温和性置于首位，严苛选材、倾心研制，旨为孕妈和婴童打造科学、放心的护肤产品。',
				// 	title1: '孕婴童护肤引领者',
				// 	titleImg: require('../../assets/mImg/zhongSwiper.jpg')
				// }
			],
			styleData: [
				"first",
				"second",
				"third",
				"forth",
				"fifth"
			]
		}
	},
	methods: {

		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},
		enter2() {
			this.$router.push('/maboutLansu')
		},
		enterAboutUs() {
			this.$router.push({ path: '/maboutLansu' });
		},
		enterBrand(id) {
			console.log(id);
			if (id == 1) {
				this.$router.push({ path: '/mhuaibrand' });
			} else if (id == 2) {
				this.$router.push({ path: '/mxinbrand' });
			} else if (id == 3) {
				this.$router.push({ path: '/myibrand' });
			} else if (id == 4) {
				this.$router.push({ path: '/mshuibrand' });
			} else {
				this.$router.push({ path: '/mzhongbrand' });
			}
		},
	}
}
</script>

<style scoped>
.mhomeCntainer {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirstBox {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
	margin-top: 0.5rem;
}

.mFirstBoxImg {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.firstBox {
	width: 100%;
	margin-top: 3.5rem;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mhomeFirstBox {
	width: 100%;
}

.mhomeFirst {
	width: 100%;
}

.mhomeSecondBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F4F5F5;
	/* padding-bottom:10rem; */
	padding-bottom: 2rem;
}

.aboutTitle1 {
	font-size: 2.25rem;
	color: #000000;
	margin-top: 1rem;
	line-height: 50px;
}

.aboutTitle2 {
	font-size: 1.25rem;
	color: #888888;
}

.mhomeSecondMain {
	width: 85%;
	flex-direction: column;
	display: flex;
	align-items: center;
}

.mhomeSecondMainimg {
	width: 100%;
	border-radius: 1rem;
	margin-top: 1rem;

}

.mhomeSecondMainText1 {
	
	font-size: 1rem;
	font-family:SourceHanSansCN-Light;
	font-weight: 300;
	color: #000000;
	margin-top: 2rem;
	line-height: 1.5rem;
	word-spacing:0.2rem;
}

.mhomeSecondMainText2 {
	font-size: 0.9rem;
	color: #20201F;
	margin-top: 1rem;
	line-height: 20px;
}

.seeMore {
	width: 10rem;
	margin-top: 1.5rem;
}


.mhomeThirdBox {
	width: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
}

.swiperBoxMain {
	width: 90%;
	/* padding-bottom: 2rem; */
	margin: 0 auto;
	border-radius: 2rem;
	padding-bottom: 3rem;
	display: flex;
	flex-direction: column;
	align-items: center;
}



.swiperBoxTitle {
	font-size: 1.5rem;
	color: #FFFFFF;
	margin-top: 2rem;
}


.swiperText {
	width: 80%;
	font-size: 1rem;
	color: #FFFFFF;
	line-height: 26px;
}

.first .swiperText {
	margin-top: 2rem;
}

.second .swiperText {
	color: #222222 !important;
	margin-top: 2rem;
}

.third .swiperText {
	color: #222222 !important;
	margin-top: 2rem;
}

.forth .swiperText {
	margin-top: 2rem;
}

.fifth .swiperText {
	margin-top: 2rem;
}

.first {
	width: 100%;
}

.second {
	width: 100%;
}

.third {
	width: 100%;
}

.forth {
	width: 100%;
}

.fifth {
	width: 100%;
}

.swiperItemBox {
	margin-top: 2rem;
}

.first .titleImg {
	width: 4rem;
	margin-top: 1.5rem;
}

.second .titleImg {
	width: 4rem;
	margin-top: 1.3rem;
}

.third .titleImg {
	width: 3.5rem;
	margin-top: 1rem;
}

.forth .titleImg {
	width: 5rem;
	margin-top: 1rem;
}

.fifth .titleImg {
	width: 6rem;
	margin-top: 1.5rem;
}


.enterSeeMore {
	width: 10rem;
	position: absolute;
	bottom: 4rem;
}

.footerBoxMain {
	width: 100%;
	/* min-height:620px; */
	background-color: #2c5eff;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
	padding-bottom: 1rem;
}

.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #fff;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	font-weight: 400;
	color: #fff;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}




.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #222222;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

/* 导航 */
.el-drawer .ltr {
	width: 60% !important;
}


.aboutLanSuImgBox {
	width: 90%;
	margin: 0 auto;
	margin-top: 1rem;
}

.aboutLanSuImg {
	width: 100%;
}

.titleContentBox {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1rem;
	position: relative;
}

.homeLine{
	width: 0.25rem;
	height: 3.3rem;
	background: #A8FC07;
	position: absolute;
	top: 0.4rem;
}

.titleIntro {
	color: #2C5EFF;
	font-family: SourceHanSansCN-Bold;
	/* font-weight: bold; */
	font-size: 1.5rem;
	font-weight: 400;
	margin-left: 1rem;
}

.titleAbout {
	font-family:SourceHanSansCN-Light;
	font-weight: 300;
	color: #6A6A6A;
	font-size: 0.8rem;
	margin-top: 0.25rem;
	margin-left: 1rem;
}

.learnMore {
	width: 8rem;
	line-height: 1.875rem;
	border: 1px solid #999;
	border-radius: 2rem;
	text-align: center;
	font-size: 0.8rem;
	cursor: pointer;
	margin-top: 2rem;
	font-family: SourceHanSansCN;
font-weight: 300;
color: #8A8B8B;
}

.swiperImgBox {
	width: 100%;
}


.swiperImg {
	width: 100%;
}

.swiperTitleBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-top: 1rem;
}

.swiperTitle {
	font-family:SourceHanSansCN-Bold;
	color: #121313;
	font-size: 1.25rem;
	font-weight: 400;
	word-spacing:0.2rem;
}

.swiperContent {
	/* color: #121313;

	font-size: 0.9rem;
	line-height: 20px;
	margin-top: 0.5rem; */
	font-size: 1rem;
	font-family:SourceHanSansCN-Light;
	font-weight: 300;
	color: #000000;
	/* margin-top: 2rem; */
	line-height: 1.5rem;
	word-spacing:0.2rem;
}

.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

.homeImgBox {
	width: 100%;
}


/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	justify-content: space-between;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	/* margin-top: 1rem; */
	align-items: center;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mhome.vue